var _g, _line, _line2, _line3, _line4, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBellOnIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 36,
    viewBox: "0 0 41 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1659_1836)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.544 36C22.7518 36 24.5427 33.9855 24.5427 31.5H16.5452C16.5452 33.9855 18.3361 36 20.544 36ZM34.008 25.4735C32.8003 24.0138 30.5406 21.818 30.5406 14.625C30.5406 9.16172 27.135 4.78828 22.5431 3.71531V2.25C22.5431 1.00758 21.6479 0 20.544 0C19.4401 0 18.5449 1.00758 18.5449 2.25V3.71531C13.953 4.78828 10.5474 9.16172 10.5474 14.625C10.5474 21.818 8.28769 24.0138 7.08 25.4735C6.70494 25.927 6.53867 26.4691 6.54179 27C6.54867 28.1531 7.35317 29.25 8.54836 29.25H32.5396C33.7348 29.25 34.5399 28.1531 34.5462 27C34.5493 26.4691 34.383 25.9263 34.008 25.4735V25.4735Z",
    fill: "#3393FF"
  }))), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 1.33333,
    y1: -1.33333,
    x2: 5.68395,
    y2: -1.33333,
    transform: "matrix(0.82163 -0.570021 0.483514 0.875337 32.6211 6.76904)",
    stroke: "#3393FF",
    strokeWidth: 2.66667,
    strokeLinecap: "round"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 1.33333,
    y1: -1.33333,
    x2: 5.68395,
    y2: -1.33333,
    transform: "matrix(-0.82163 -0.570021 -0.483514 0.875337 8.46484 7.38477)",
    stroke: "#3393FF",
    strokeWidth: 2.66667,
    strokeLinecap: "round"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 35.0521,
    y1: 13.1281,
    x2: 39.1664,
    y2: 13.1281,
    stroke: "#3393FF",
    strokeWidth: 2.66667,
    strokeLinecap: "round"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 1.83333,
    y1: 13.1281,
    x2: 5.94762,
    y2: 13.1281,
    stroke: "#3393FF",
    strokeWidth: 2.66667,
    strokeLinecap: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1659_1836"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28.0044,
    height: 36,
    fill: "white",
    transform: "translate(6.54297)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBellOnIcon);
export default __webpack_public_path__ + "static/media/bell-on-icon.7048cf0c47e43552e3dcdb375bce3b07.svg";
export { ForwardRef as ReactComponent };